import { TwoFactorSettings } from './TwoFactorSettings'
import { WebAuthnSettings } from './WebAuthnSettings'
import { ChangePassword } from './ChangePassword'
import { MySessions } from './MySessions'

export function SettingsPage() {
  return (
    <div className="page">
      <h2>Account Settings</h2>
      <div className="card-stack">
        <section className="card">
          <TwoFactorSettings />
        </section>
        <section className="card">
          <WebAuthnSettings />
        </section>
        <section className="card">
          <MySessions />
        </section>
        <section className="card">
          <ChangePassword />
        </section>
      </div>
    </div>
  )
}
